// 给客户端(如安卓、ios)调用挂在 window 上的 js 方法，加后缀防止冲突
class WindowLib {
  constructor() {
    // 与原生约定的后缀：window.<name>NativeFn
    this.nameSuffix = 'NativeFn'
  }

  // 把回调挂到 window.<name>NativeFn
  // options.cover = true（默认）时，同名覆盖；false 时已存在则不覆盖
  addAttr(name, value, options = { cover: true }) {
    const realName = name + this.nameSuffix
    if (!options.cover && window[realName] !== undefined) {
      return false
    }
    window[realName] = value
    return true
  }

  // 从 window 删除 window.<name>NativeFn
  removeAttr(name) {
    const realName = name + this.nameSuffix
    delete window[realName]
  }
}

export default WindowLib
